import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface IGridsInitialState {
  [gridName: string]: any; // eslint-disable-line
}

interface IUpdateColAction {
  gridName: string;
  gridState: any; // eslint-disable-line
}

const initialState: IGridsInitialState = {};

export const gridsSlice = createSlice({
  name: 'grids',
  initialState,
  reducers: {
    updateGridState: (state, { payload: { gridName, gridState } }: PayloadAction<IUpdateColAction>) => {
      state[gridName] = gridState;
    },
    resetGridsState: (_state) => initialState,
  },
});

export const { updateGridState, resetGridsState } = gridsSlice.actions;

export const selectGridState =
  (gridName = '') =>
  (state: RootState) =>
    state.grids[gridName];
